import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M21 11H6.4l5.3-5.3-1.4-1.4L2.6 12l7.7 7.7 1.4-1.4L6.4 13H21v-2z" }));
export {
  o as ReactComponent
};
